export enum ThumbnailAttachmentTypeEnum {
  Size_100x100 = 'thumbnail_size_100x100',
  Size_340xAuto = 'thumbnail_size_340xAuto',
}
